import React from "react";

import {
  borderColorSecondary,
  spacing4,
  spacing8,
  backgroundColorLevelCurrent,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const sizeXL = 74;
const sizeLarge = 40;
const sizeSmall = 26;
const IconHolderSmall = styled.div`
  margin-right: ${spacing8};
  box-shadow: 0px 2px 5px ${borderColorSecondary};
  border-radius: ${sizeSmall / 2}px;
  padding-top: ${spacing4};
  padding-bottom: ${spacing4};
  padding-left: ${spacing8};
  padding-right: ${spacing8};
  width: ${sizeSmall}px;
  height: ${sizeSmall}px;
  position: relative;
  background-color: ${backgroundColorLevelCurrent};
`;
const IconHolderLarge = styled.div`
  margin-right: ${spacing8};
  box-shadow: 0px 2px 5px ${borderColorSecondary};
  border-radius: ${sizeLarge / 2}px;
  padding-top: 12px;
  padding-bottom: ${spacing4};
  padding-left: 12px;
  padding-right: ${spacing8};
  width: ${sizeLarge}px;
  height: ${sizeLarge}px;
  position: relative;
  background-color: ${backgroundColorLevelCurrent};
`;
const IconHolderXL = styled.div`
  cursor: pointer;
  margin-right: ${spacing8};
  box-shadow: 0px 2px 5px ${borderColorSecondary};
  border-radius: ${sizeXL / 2}px;
  padding-top: 12px;
  padding-bottom: ${spacing4};
  padding-left: 12px;
  padding-right: ${spacing8};
  width: ${sizeXL}px;
  height: ${sizeXL}px;
  position: relative;
  background-color: ${backgroundColorLevelCurrent};
`;

const ShadowCircleIcon = ({ children, size = "large" }) => {
  switch (size) {
  case "large":
    return <IconHolderLarge>{children}</IconHolderLarge>;
  case "xl":
    return <IconHolderXL>{children}</IconHolderXL>;
  default:
    return <IconHolderSmall>{children}</IconHolderSmall>;
  }
};

export default ShadowCircleIcon;
